<template>
  <div class="agreementBody">
    <Header />
    <div class="agreementMain">
      <h1>《豸信CA实名认证服务协议》</h1>
      <p>更新时间：2023年8月15日</p>
      <p>生效时间：2023年8月15日</p>
      <p>欢迎使用豸信CA实名认证服务！</p>
      <p>根据法律法规的相关要求，基于数字证书颁发，数字证书使用，合同等需要，豸信CA需要您根据我们的指引完成实名认证。为了使用实名认证服务（以下简称“本服务”），请您仔细阅读并确认《实名认证服务协议》（以下简称“本协议”）。</p>
      <p>本协议中与您的权益（可能）存在重大关系的条款（包括免除我们责任的条款、限制用户权利的条款、约定的争议解决方式及司法管辖条款等），豸信CA（以下或称“我们”）已采用字体加粗的方式来特别提醒您，请您留意重点查阅。您应当在确认充分阅读字体加粗条款，明确理解的前提下使用本服务。</p>
      <p style="font-weight: 600;font-size: 18px;">一、 实名认证服务内容</p>
      <p style="font-weight: 600;">1. 在本协议中所使用的下列词语，除非另有定义，应具有以下含义：</p>
      <p>“网站”、“本平台”、“本服务”在无特别说明的情况下均指“实名认证服务平台”。</p>
      <p>“第三方”指独立于实名认证服务之外的某个独立的网站平台和机构。</p>
      <p>服务的具体内容由本平台根据实际情况提供。我们保留随时变更、中断或终止部分或全部网络服务的权利。</p>
      <p>2. 您应完整提供必要的实名认证信息并确保所提供的实名认证信息真实准确、合法有效，不采用任何任何违法违规、不正当或欺骗手段使用本服务。</p>
      <p style="font-weight: 600;">3. 如豸信CA发现或接举报发现您在使用本服务过程中存在违反本协议约定的行为，豸信CA有权中止或终止部分或全部豸信CA服务，包括但不限于对账号采取封禁、冻结等限制措施。</p>
      <p style="font-weight: 600;">4、目前本平台向您提供以下实名认证服务：</p>
      <p>个人信息是指以电子或者其他方式记录的与已识别的自然人有关的各种信息，不包括匿名化处理后的信息。</p>
      <p>敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严收到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</p>
      <p style="font-weight: 600;">4.1 您在进行实名认证的时候需要主动提供的信息</p>
      <p>当您进行个人实名认证时，您需要提供您的姓名、证件类型、证件号码、实名手机号、银行号码信息。如果您进行企业实名认证（包括但不限于法人、政府机构、其他组织、合伙或个体工商户等），您需要提供您的企业名称、组织机构代码/统一社会信用代码、法定代表人姓名、证件类型、证件号码以及实名手机号码。上述信息是为了帮助您完成实名认证，若您不提供这类信息，您将无法使用我们的服务。</p>
      <p style="font-weight: 600;">4.2 如您进行实名认证，我们将根据您所使用的不同身份核验方式收集您的相应信息</p>
      <ul style="font-weight: 600;">
        <li>（1）当您使用运营商实名信息核验方式时，我们会收集您的姓名、实名手机号、身份证号码。</li>
        <li>（2）当您使用银行卡鉴权的身份核验方式时，我们会收集您的姓名、身份证号、银行预留手机号码。</li>
        <li>（3）当您使用生物识别特征比对的身份核验方式时，我们会收集您的姓名、身份证号、脸部影像。</li>
        <li>（3）当您使用生物识别特征比对的身份核验方式时，我们会收集您的姓名、身份证号、脸部影像。</li>
        <li>（4）如果您是企业用户，您需要提供您的营业执照/组织机构代码/统一社会信用代码、对公银行账号，其中法定代表人和经办人提供信息的类型参考上述不同身份核验方式。</li>
        <li>（5）您理解并确认，为了履行存储实名信息义务，豸信CA将根据法律法规存储您的相关信息，存储信息内容取决于您使用哪种实名方式，为核验用户信息的真实性准确性，豸信CA保存您的数据并传递给合法的三方机构或政府机构进行比对验证。</li>
      </ul>
      <p>5. 豸信CA向您承诺，我们会根据《豸信CA隐私政策》保障您的个人信息安全并严格要求第三方合作供应商对您的个人信息保密，只以实名认证之目的获悉和使用，不得对无关方泄露或做其他任何用途。</p>
      <p style="font-weight: 600;font-size: 18px;">二、适应范围</p>
      <p>实名认证服务适用于本平台的所有用户。</p>
      <p style="font-weight: 600;font-size: 18px;">三、认证流程</p>
      <p style="font-weight: 600;">1.个人实名认证</p>
      <ul>
        <li>（1）个人实名手机号认证：用户在实名认证页面填写真实姓名、证件号码、实名手机号信息，检验运营商三要素是否通过，获取验证码进行实名验证。</li>
        <li>（2）个人银行卡号验证：用户在实名认证页面填写真实姓名、证件号码、实名手机号、个人银行卡号信息，检验银行卡四要素是否通过，获取验证码进行实名验证。</li>
        <li>（3）个人刷脸认证：用户在实名认证页面填写真实姓名、证件号码，扫码完成刷脸验证</li>
      </ul>
      <p>2. 企业实名认证</p>
      <ul>
        <li>（1）法定代表人认证：用户在企业实名认证页面填写企业名称、统一社会信用代码、法定代表人姓名、法定代表人证件号码信息，进入法人认证页面，法人进行刷脸或实名手机号进行实名验证。</li>
        <li>（2）对公打款认证：用户在企业实名认证页面填写企业名称、统一社会信用代码、法定代表人姓名、法定代表人证件号码（选填）信息，进入对公打款验证页面，回填打款金额进行实名验证。</li>
      </ul>
      <p style="font-weight: 600;font-size: 18px;">四、隐私保护</p>
      <p>1. 您在认证时提交给本平台的认证资料和认证信息，即不可撤销的授权由本平台保留。本平台承诺除法定或约定的事由外，不公开或编辑或透露您的认证资料及保存在本平台的非公开内容用于商业目的，但下列情况除外：</p>
      <ul>
        <li>（1）您授权本平台透露的相关信息；</li>
        <li>（2）本平台向国家司法及行政机关提供；</li>
        <li>（3）本平台向本平台关联企业提供；</li>
        <li>（4）第三方和本平台一起为用户提供服务时，该第三方向您提供服务所需的相关信息。</li>
      </ul>
      <p>2. 我们将采取商业上合理的方式以保护您个人资料的安全。我们将使用通常可以获得的安全技术和程序来保护您的个人资料不被未经授权的访问、使用或泄漏。</p>
      <p style="font-weight: 600;font-size: 18px;">五、免责声明</p>
      <p style="font-weight: 600;">下列情况时本平台无需承担任何责任：</p>
      <p>1. 您明确同意使用我们的网络服务，所存在的风险将完全由您自己承担；因您使用我们网络服务而产生的一切后果也由您自己承担，我们对您不承担任何责任。</p>
      <p style="font-weight: 600;">2. 由于您将Ukey密码或者其他有关平台的密码告知他人或未保管好自己的密码或与他人共享本平台账户或任何其他非本平台的过错，导致您的个人资料泄露。</p>
      <p>3. 由于第三方原因(包括不可抗力，例如国际出口的主干线路及国际出口电信提供商一方出现故障、黑客攻击、电信部门技术调整导致之重大影响、因政府管制导致的暂时关闭、病毒侵袭等影响互联网正常运行、火灾、水灾、雷击、地震、洪水、台风、龙卷风、火山爆发、瘟疫和传染病流行、罢工、战争或暴力行为或类似事件等)及其他非因本平台过错而造成的认证信息泄露、丢失、被盗用或被篡改等。</p>
      <p>4. 本平台用户（包括未成年人用户）向本平台提供错误、不完整、不实信息等造成不能通过认证或遭受任何其他损失，概与本平台无关。</p>
      <p style="font-weight: 600;font-size: 18px;">六、 修改和解释权</p>
      <p>1. 本中心有权单方随时修改或变更本协议内容，并通实名认证服务平台公告变更后的协议文本，无需单独通知您。本协议进行任何修改或变更后，您还继续使用实名认证服务的，即代表您已阅读、了解并同意接受变更后的协议内容，且不得因此而要求任何补偿或赔偿；您如果不同意变更后的协议内容，可停止使用我们所提供的服务。</p>
      <p>2. 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国法律。本协议项下因与中华人民共和国现行法律冲突而导致部分无效，不影响其他部分的效力。</p>
      <p>3. 本协议未尽事宜，或与国家、地方有关规定相悖的，按有关规定执行。</p>
      <p>4. 我们保留对本协议条款、产品和服务以及我们所提供的产品和服务的相关官方网站的最终解释权。</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.agreementBody {
  background: #f1f3f7;
}
.agreementMain {
  width: 1600px;
  margin: 16px auto 0;
  padding: 32px;
  background: #fff;
  color: #333;
  h1 {
    font-size: 24px;
    text-align: center;
    padding-bottom: 32px;
  }
  h2 {
    font-size: 18px;
    text-align: center;
    padding: 32px 0;
  }
  p {
    text-indent: 2em;
    line-height: 30px;
  }
  ul {
    margin-left: 70px;
    text-indent: 2em;
    list-style: inside;
    line-height: 24px;
    li {
      list-style-position: inherit;
    }
  }
}
</style>